import { render, staticRenderFns } from "./TreeTableRowPermissions.vue?vue&type=template&id=5f7ebcf2&scoped=true&"
import script from "./TreeTableRowPermissions.vue?vue&type=script&lang=js&"
export * from "./TreeTableRowPermissions.vue?vue&type=script&lang=js&"
import style0 from "./TreeTableRowPermissions.vue?vue&type=style&index=0&id=5f7ebcf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ebcf2",
  null
  
)

export default component.exports